// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"c1bdce02","174":"1f1162f7","460":"6a80763a","638":"aee0a1f3","726":"0781c624","889":"01486813"}[chunkId] + ".css";
};